import { useState } from "react";
import { sendEmail } from "JS/API";
import { FaWindowClose } from "react-icons/fa";
import EmailCancelModal from "Components/Agencies/EmailCancelModal";
import ReactQuill from "react-quill";

const EmailSendModal = ({ setEmailModal }) => {
  const [emailData, setEmailData] = useState({
    email: "",
    user_name: "",
    subject: "",
    email_type: "",
  });

  const [selectedTemplate, setSelectedTemplate] = useState("default");

  const [content, setContent] = useState("");

  const [cancelModal, setCancelModal] = useState(false);

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setEmailData((prev) => ({ ...prev, [id]: value }));
  };

  const handleTempChange = (e) => {
    setSelectedTemplate(e.target.value);
  };
  return (
    <div className="modal-background">
      <div className="email-modal-container">
        <div className="email-modal-header">
          <h3 className="email-modal-title">메일 발송</h3>
          <div
            className="email-modal-close"
            onClick={() => setEmailModal(false)}
          >
            <FaWindowClose />
          </div>
        </div>
        <div className="email-modal-subheader">
          <select
            className="selectTemp"
            value={selectedTemplate}
            onChange={handleTempChange}
          >
            <option value="default">템플릿 유형</option>
            <option value="temp1">템플릿 1</option>
            <option value="temp2">템플릿 2</option>
          </select>
          <button className="email-changeTemp-button">변경</button>
        </div>
        <div className="email-modal-content">
          <div className="email-field">
            <label className="email-field-label">보내는 이름</label>
            <input
              className="email-field-value"
              value={emailData.user_name}
              onChange={handleInputChange}
              type="text"
              id="user_name"
              placeholder="마크픽 관리자"
            />
          </div>
          <div className="email-field">
            <label className="email-field-label">받는 사람</label>
            <input
              className="email-field-value"
              value={emailData.email}
              onChange={handleInputChange}
              type="email"
              id="email"
              placeholder="info@markpick.co.kr"
              style={{ width: "100%" }}
            />
          </div>
          <div className="email-field-full">
            <label className="email-field-label">메일 제목</label>
            <input
              className="email-field-value"
              value={emailData.subject}
              onChange={handleInputChange}
              type="text"
              id="subject"
              placeholder="ex) 출원대행 관련 피드백 전송드립니다"
              style={{ width: "100%" }}
            />
          </div>
          <div className="email-field-full">
            <ReactQuill
              className="email-editor"
              value={content}
              onChange={setContent}
              theme="snow"
            />
          </div>
        </div>
        <div className="email-modal-footer">
          <button
            className="email-send-button"
            onClick={() => {
              const typeChanged = {
                ...emailData,
                email_type: selectedTemplate,
              };
              sendEmail(typeChanged)
                .then((res) => {
                  if (res.status === 200) {
                    alert("이메일이 정상적으로 발송처리 되었습니다!");
                    setEmailModal(false);
                  } else {
                    alert("이메일 발송에 실패했습니다.");
                  }
                })
                .catch((err) => {
                  console.error(err);
                  alert("e메일 발송에 실패했습니다.");
                });
            }}
          >
            전송
          </button>
          <button
            className="email-cancel-button"
            onClick={() => setCancelModal(true)}
          >
            취소
          </button>
        </div>
      </div>
      {cancelModal && (
        <EmailCancelModal
          setEmailModal={setEmailModal}
          setCancelModal={setCancelModal}
        />
      )}
    </div>
  );
};

export default EmailSendModal;
